import Page from 'src/components/Page';
import Table from 'src/components/Table';

function AVSResultCodesPage() {

    return <Page header="AVS Result Codes">
        <h2 id="cvnResponseCodes">Billpay AVS result codes</h2>
        <Table
            headers={['Normalized Result', 'Description']}
            body={[
                [<code>FULL_MATCH</code>, 'Address and postal code match'],
                [<code>PARTIAL_MATCH</code>, 'Some address elements match'],
                [<code>NO_MATCH</code>, 'Address verification failed'],
                [<code>NOT_SUPPORTED</code>, 'AVS not supported by issuer / network'],
                [<code>NOT_AVAILABLE</code>, 'AVS unavailable or not returned'],
                [<code>SYSTEM_UNAVAILABLE</code>, 'Temporary issuer / network failure'],
                [<code>NOT_REQUESTED</code>, 'AVS not requested or disabled'],
                [<code>UNRECOGNIZED</code>, 'Gateway returned an unknown value']
            ]}
        />

        <h2 id="cvnResponseCodes">Cybersource AVS raw result codes</h2>
        <Table
            headers={['Code', 'Normalized']}
            body={[
                [<code>Y, X, D, M, V</code>, 'FULL_MATCH'],
                [<code>A, B, F, H, K, L, O, P, T, W, Z</code>, 'PARTIAL_MATCH'],
                [<code>N, C, I, 5</code>, 'NO_MATCH'],
                [<code>E, S, G, 1</code>, 'NOT_SUPPORTED'],
                [<code>R, U</code>, 'SYSTEM_UNAVAILABLE'],
                [<code>2</code>, 'UNRECOGNIZED']
            ]}
        />

        <h2 id="cvnResponseCodes">MPGS AVS raw result codes</h2>
        <Table
            headers={['Code', 'Normalized']}
            body={[
                [<code>ADDRESS_MATCH, ADDRESS_ZIP_MATCH</code>, 'FULL_MATCH'],
                [<code>NAME_ADDRESS_MATCH, NAME_ZIP_MATCH, ZIP_MATCH, NAME_MATCH</code>, 'PARTIAL_MATCH'],
                [<code>NO_MATCH</code>, 'NO_MATCH'],
                [<code>NOT_SUPPORTED</code>, 'NOT_SUPPORTED'],
                [<code>NOT_AVAILABLE, NOT_VERIFIED</code>, 'NOT_AVAILABLE'],
                [<code>NOT_REQUESTED</code>, 'NOT_REQUESTED'],
                [<code>SERVICE_NOT_AVAILABLE_RETRY</code>, 'SERVICE_NOT_AVAILABLE_RETRY']
            ]}
        />
    </Page>;
}

export default AVSResultCodesPage;